import SYNCH_WITH_MYCASA from 'shared-constants/src/synchWithMycasa';
import LAST_SYNCH_TS from 'shared-constants/src/lastSynchTimestamp';

import { getItem } from '../localStorage';

const getIsLastSynchExpired = (lastSynch) => {
  if (!lastSynch) { // se non c'è l'ultimo timestamp, devo chiamare
    return true;
  }
  const secondsElapsed = Math.floor((Date.now() - parseInt(lastSynch, 10)) / 1000);
  const oneHourInSeconds = 60 * 60;
  // se è passata più di un'ora dall'ultima chiamata, devo chiamare
  if (secondsElapsed > oneHourInSeconds) {
    return true;
  }
  return false;
};

export default () => {
  const mycasaLS = getItem(SYNCH_WITH_MYCASA);
  const isMycasaForcingSynch = !!mycasaLS;

  const lastSynch = getItem(LAST_SYNCH_TS);
  const isLastSynchExpired = getIsLastSynchExpired(lastSynch);

  return isMycasaForcingSynch || isLastSynchExpired;
};
